import React from "react";

import { useLocation, withRouter } from "react-router-dom";
import styled from "styled-components";

import { ServiceLink } from "components/Navigation/ServiceLink";


import { Badge, Nav } from "rsuite";

const activeRouteAliases = {
    "/accounts": ["/accounts/view", "/accounts/new"],
    "/sms-suppliers": ["/sms-suppliers/view", "/sms-suppliers/new"],
    "/suppliers": ["/suppliers/view", "/suppliers/new"],
};

const routeMatches = (route, pathname) => {
    if (!route) return false;

    if (pathname === route || pathname.indexOf(`${route}/`) === 0) {
        return true;
    }

    return (activeRouteAliases[route] || []).some(alias => (
        pathname === alias || pathname.indexOf(`${alias}/`) === 0
    ));
};

export default ({
    data = [],
}) => {
    const location = useLocation();
    const activeKey = data.reduce((result, item) => {
        if (result) return result;

        if (item.children && item.children.length) {
            const activeChild = item.children.find(subItem => routeMatches(subItem.key, location.pathname));
            return activeChild ? activeChild.key : result;
        }

        return routeMatches(item.key, location.pathname) ? item.key : result;
    }, location.pathname);

    return (
        <Nav appearance="subtle" activeKey={activeKey}>
            {data.map((item, index) => {
                const itemKey = item.key || `menu-${index}-${item.title}`;

                const itemContent = <>{item.icon && item.icon}{item.title}</>;

                if (item.children) {
                    if (item.children.length) {
                        return (
                            <MenuDropdown
                                key={itemKey}
                                item={item}
                                itemKey={itemKey}
                                badge={item.badge}
                                badgeLink={item.badgeLink}
                            />
                        )
                    } else {
                        return null;
                    }
                }

                return item.onClick
                    ? <NavLink
                        key={itemKey}
                        eventKey={item.key}
                        badge={item.badge}
                        badgeLink={item.badgeLink}
                        onClick={item.onClick}
                        to={item.key}
                    >
                        {itemContent}
                    </NavLink>
                    : <NavLink
                        key={itemKey}
                        badge={item.badge}
                        badgeLink={item.badgeLink}
                        to={item.key}
                    >
                        {itemContent}
                    </NavLink>
            })}
        </Nav>
    )
};


const NavLink = withRouter((
    {
        badge,
        badgeLink,
        ...props
    }
) => {
    const eventKey = props.eventKey || props.to;
    const navItem = <StyledNavItem
        {...props}
        forwardedAs={ServiceLink}
        to={props.to}
        eventKey={eventKey}
        active={routeMatches(eventKey, props.location.pathname)}
    />;

    return badge
        ? <StyledBadge content={badge}>{navItem}</StyledBadge>
        : navItem
});


const MenuDropdown = (
    {
        item,
        itemKey,
        badge
    }
) => {

    const location = useLocation();
    const isSubMenuActive = item.children.find(item => routeMatches(item.key, location.pathname));

    if (item.children && !item.children.length) {
        return null;
    }

    const dropdown = (
        <StyledNavMenu
            key={itemKey}
            active={!!isSubMenuActive}
            eventKey={itemKey}
            title={item.title}
        >
            {item.children.map(subItem => {
                return <Nav.Item
                    key={subItem.key}
                    as={ServiceLink}
                    to={subItem.key}
                    eventKey={subItem.key}
                    onClick={subItem.onClick || null}
                >
                    {subItem.title}
                </Nav.Item>
            })}
        </StyledNavMenu>
    );


    return badge
        ? <StyledBadge content={badge}>{dropdown}</StyledBadge>
        : dropdown
};


const StyledNavMenu = styled(Nav.Menu)`
    &&&&&& {

        .rs-dropdown-menu {
            min-width: 120px;
        }

        .rs-dropdown-toggle-caret {
            left: 0;
            padding: 0;
            position: inherit;
            transition: left .3s ease-out,right .3s ease-out;
        }

        .rs-dropdown-item-active {
            border-left: 3px solid var(--color-brand1);
        }
        
        .rs-dropdown-toggle {
            background-color: transparent !important;
            padding: 18px 16px;
        }
    }
`;

const StyledNavItem = styled(Nav.Item)`
    &&&&& {
        .rs-nav-item-content,
        &.rs-nav-item {
            color: #fff;
        }

        .rs-icon,
        svg {
            margin-right: 5px;
        }
    }
`;


const StyledBadge = styled(Badge)`
    && .rs-badge-content {
        top: 15px;
        z-index: 7;
        
        a {
            border-radius: 8px;
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
        }
    }
`;
